
class ParticipantModel{
	constructor()
	{
		this.id 			= null;
		this.firstName 		= null;
		this.lastName 		= null;
		this.email 			= null;
		this.image 			= null;
		this.userType 		= null;
		this.currentStatus	= null;
		this.order 			= null;
		this.subscribeTime 	= null;
		this.isVisible 		= null;
		this.audioMuted 	= null;
		this.videoMuted 	= null;
		this.forcedSwapIn 	= null;
		this.raisedHand 	= null;
		this.raisedHandTime = null;
		this.isAvailableAtRTC = null;
		this.isAvailableAtRTM = null;
		this.loggedIn 		= null;
		this.cameraAccess 	= null;
		this.micAccess 		= null;
		this.isPin 			= null;
		this.hasPoorNetwork = null;
		this.broadcastVideo = null;
		this.debounceValue  = null;
		this.broadcastVideoHost = null;
		this.attendedClasses = null;
	}

}

export default ParticipantModel;